import { every, map } from 'lodash-es';

import { isEmpty, isObject } from '@utils/guards';

export function isObjectEmpty(data: unknown): boolean {
  if (isEmpty(data))
    return true;

  if (isObject(data)) {
    return every(map(data, (val) => isObjectEmpty(val)));
  }

  return false;
}
